module.exports = __webpack_public_path__ + "img/237.compressor.b783f18c.svg";